import { useState, useEffect } from 'react';
import { Fetch } from '../services/api';
import { notify } from '../utils/utils';

const urlPGI = process.env.REACT_APP_PGI_API + "/General/";
export const useEmpresas = () => {
    const [ empresas, setEmpresas ] = useState([]);
    const [ rutas, setRutas ] = useState([]);

        const listarEmpresas = async () => {
            const response = await Fetch({url:'https://xprojectwebapi.abexacloud.com/api/General/companies'})

            if (response.isValid) {
                setEmpresas(response.content)
            }
        }

        const listarRutasPorEmpresa = async (codEmpresa) => {
            try{
                const response = await Fetch({ url: urlPGI + 'routesByCompanie?' + new URLSearchParams({
                        CodEmpresa: codEmpresa
                    })
                })
                !response.isValid && notify(response.exceptions[0].description, 'error');
                setRutas(response.isValid ? response.content : []);
            }
            catch(e){
                notify('Ocurrió un error en el servicio', 'error');
                setRutas([]);
                console.log('Error al listar rutas por empresa: ',e)
            }
        }
    
    return {
        empresas,
        listarEmpresas,
        listarRutasPorEmpresa,
        rutas,
    }
}

